import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getVpoolInfo as _getVpoolInfo,
  getMinMaxParticipation,
  getPoolsUserSubscribedFor as _getPoolsUserSubscribedFor,
  getMaxPoolAllocation,
} from '../../services/vpoolService';
import { divideOnWei } from '../../utils/mapper';
import { usePromise } from '../usePromise/usePromise';

export const useVpoolInfo = (poolAddress, web3HpoolId) => {
  const account = useSelector((state) => state.wallet?.account);
  const [getPoolsUserSubscribedFor, subscribedVPools] = usePromise(_getPoolsUserSubscribedFor);
  const [getVpoolInfo, vPoolInfo = {}, vPoolInfoLoading] = usePromise(_getVpoolInfo);
  const [getMinMaxParticipationReq, minMaxParticipation] = usePromise(getMinMaxParticipation);
  const [_getMaxPoolAllocation, maxPoolAllocation, gettingMaxPoolAllocation] = usePromise(getMaxPoolAllocation);

  const minMaxParticipationRawValsArr = minMaxParticipation?.map((prop) => prop?.value || 0);
  const [minParticipation, maxParticipation] = minMaxParticipationRawValsArr || [];
  const minParticipationUsd = +divideOnWei(minParticipation) || 0;
  const maxParticipationUsd = +divideOnWei(maxParticipation) || 0;

  const maxPoolAllocationInUsd = +divideOnWei(maxPoolAllocation) || 0;

  const fundsCollected = divideOnWei(vPoolInfo?.[8]) || 0;

  useEffect(() => {
    // doesnt seem to work with this check in place
    // if (!poolAddress) return;
    getVpoolInfo(web3HpoolId);
  }, [poolAddress, web3HpoolId]);

  useEffect(() => {
    if (account) getPoolsUserSubscribedFor(account);
  }, [account]);

  // These values are fixed and dont depend on vpool contract
  useEffect(() => {
    getMinMaxParticipationReq();
    _getMaxPoolAllocation();
  }, []);

  return {
    fundsCollected,
    minParticipationUsd,
    maxParticipationUsd,
    vPoolInfoLoading,
    subscribedVPools,
    maxPoolAllocationInUsd,
  };
};
